import { render, staticRenderFns } from "./goods-price.vue?vue&type=template&id=17005a38&scoped=true"
import script from "./goods-price.vue?vue&type=script&lang=js"
export * from "./goods-price.vue?vue&type=script&lang=js"
import style0 from "./goods-price.vue?vue&type=style&index=0&id=17005a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17005a38",
  null
  
)

export default component.exports